import "./App.css";
import Navbar from "./Navbar"
import ProfilField from "./ProfilField"
import SocialField from "./SocialField"

function App() {
  return (
    <div className="App">
           <Navbar/>
           <img  className="bg" src={"/bg.jpg"} alt="bg"/>
           <div className="field">
                <ProfilField className="profilfield"/>
                <SocialField/>
           </div>
    </div>
  );
}

export default App;
